module.exports = __webpack_public_path__ + "img/commerce.498784bd.svg";